module.exports = __webpack_public_path__ + "img/cover-redeem-bg-mobile.40050f72.png";